module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_s50x50-e187121d2c69e2d3c03406c8dde4b3c9.jpg";